import React from "react";
import _ from "lodash";
import {Comparison} from "./comparison";

export function playerComparisonUrl(playerIds) {
    let newIds = _.join(_.slice(playerIds, 0, 6), '-');
    return "/playercomparison/" + newIds;
}

export const PlayerComparison = () => <Comparison type="player"/>